import { onMounted, watch } from 'vue';
import { usePostSaleCaseDetail } from './usePostSaleCaseDetail';
import { usePostSaleOverview } from './usePostSaleOverview';
import { usePostSaleRouteState } from './usePostSaleRouteState';

export function usePostSaleCases({ route, router, t, notify, initialSection }) {
  const routeState = usePostSaleRouteState({ route, router, initialSection });
  const overview = usePostSaleOverview({ ...routeState, t, notify });
  const detail = usePostSaleCaseDetail({ ...overview, t, notify });

  const refresh = () => overview.refresh();

  const selectSection = value => {
    routeState.activeSection.value = value;
    routeState.syncIndex();

    if (value === 'vendas') overview.loadCases();
    if (value === 'gestao') overview.loadDashboard();
  };

  const selectList = value => {
    routeState.activeList.value = value;
    routeState.sort.value = '';
    routeState.page.value = 1;
    overview.loadCases();
    overview.loadClients(value);
    routeState.syncIndex();
  };

  const setManagementTab = value => {
    routeState.managementTab.value = value;
    routeState.syncIndex();
  };

  const applyFilters = filters => {
    routeState.filters.value = filters;
    routeState.page.value = 1;
    overview.loadCases();
    routeState.syncIndex();
  };

  const applySort = value => {
    routeState.sort.value = value;
    routeState.page.value = 1;
    overview.loadCases();
    routeState.syncIndex();
  };

  const openFilteredList = filters => {
    routeState.activeSection.value = 'vendas';
    routeState.activeList.value = 'andamento';
    routeState.sort.value = '';
    routeState.filters.value = filters;
    routeState.page.value = 1;
    overview.loadCases();
    routeState.syncIndex();
  };

  const clearFilters = () =>
    applyFilters({
      q: '',
      responsible_user_id: '',
      priority: '',
      deadline: '',
      payment_method: '',
      laudemio_type: '',
      clients: [],
      address_street: '',
      address_number: '',
      address_unit: '',
    });

  const changePage = nextPage => {
    routeState.page.value = Math.max(
      1,
      Math.min(nextPage, overview.totalPages.value)
    );
    overview.loadCases();
    routeState.syncIndex();
  };

  watch(
    routeState.routePostSaleCaseId,
    postSaleCaseId => {
      if (postSaleCaseId) detail.load(postSaleCaseId);
      else detail.clear();
    },
    { immediate: true }
  );

  onMounted(() => {
    Promise.all([refresh(), overview.loadAgents()]);
  });

  return {
    ...detail,
    ...overview,
    ...routeState,
    applyFilters,
    applySort,
    changePage,
    clearFilters,
    openFilteredList,
    refresh,
    selectList,
    selectSection,
    setManagementTab,
  };
}
